import PropTypes from 'prop-types';

const CloseIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.053 1.793 23.98 15.734l13.935-13.94c5.45-5.453 13.797 2.751 8.27 8.281L32.258 24.007l13.926 13.94c5.441 5.435-2.837 13.717-8.27 8.274L23.98 32.289 10.053 46.22c-5.441 5.443-13.71-2.839-8.278-8.273L15.71 24.007 1.775 10.075C-3.657 4.632 4.612-3.65 10.053 1.793z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

CloseIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

CloseIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default CloseIcon;
